import "./Banner01.css";
import videoSrc from "../../../video/Kingsway.mp4"; // Import your video

function Banner01() {
  return (
    <div className="Banner01 section">
      <video className="Banner01-video" autoPlay muted loop playsInline>
        <source src={videoSrc} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div className="container">
        <div className="Banner01-box">
          <p className="eyebrow green2">LOCATIONS</p>
          <h2>Find Your Local Razor King.</h2>
          <p>
            Explore our three barbershop locations and book your appointment
            today.
          </p>
          <a href="/locations" className="btn-3">
            ALL LOCATIONS
          </a>
        </div>
      </div>
    </div>
  );
}

export default Banner01;
